import * as React from "react";
import { observer } from "mobx-react";
import { useStore } from "../../App";
import { Text, Box, Heading, FormControl, FormLabel, Switch } from "@chakra-ui/core";
import SegmentedControl, { SegmentedControlOption } from "../../ui/el/SegmentedControl";
import { View } from "../../store/Store";
import { styled } from "../../ui/theme";

export default observer(function Control() {
  const store = useStore();

  return (
    <Box p="16px 32px">
      <Heading size="md" mb="10px" fontWeight="lighter" color="white">
        Corona Caard
      </Heading>
      <p style={{ fontSize: "11px", marginBottom: "16px" }}>
        Helaas heeft de RIVM z'n data (weer) veranderd. U kunt de oude data{" "}
        <a href="https://coronb.caard.nl/" target="_blank" style={{ textDecoration: "underline" }}>
          hier
        </a>{" "}
        bekijken. We zullen later de oude data in dit zelfde dashboard proberen te tonen.
      </p>
      <p style={{ fontSize: "11px", marginBottom: "16px" }}>
        bron:{" "}
        <a
          style={{ textDecoration: "underline" }}
          href="https://www.rivm.nl/nieuws/actuele-informatie-over-coronavirus"
          target="_blank"
        >
          RIVM
        </a>
        &nbsp;&nbsp;&nbsp; made by:&nbsp;
        <a style={{ textDecoration: "underline" }} href="https://spatialexplorers.com" target="_blank">
          Spatial Explorers
        </a>
      </p>
    </Box>
  );
});
